// Which flat a delivery or subscription goes to — shown under the customer's
// name on the admin screens, so customers with the same name can be told
// apart at a glance.
//
// Apartment addresses carry `flat_number` + `apartment_name` (their line1 is
// "flat, apartment"). Typed addresses have only free text — unless the store
// requires a flat / house number (Settings → "Require flat / house number"),
// in which case they carry their own `flat_number` too.

const clean = (v) => String(v || "").trim();

/** True when `line` already starts with the flat (e.g. "703, NCC Urbania"). */
function startsWithFlat(line, flat) {
  if (!flat) return true;
  const l = line.toLowerCase();
  const f = flat.toLowerCase();
  return l === f || l.startsWith(`${f},`) || l.startsWith(`${f} `) || l.startsWith(`flat ${f}`);
}

/** line1 with a typed address's own flat number in front when line1 does
 *  not already start with it. Apartment addresses are returned as they are
 *  (their line1 is built from the flat already). */
export function lineWithFlat(address) {
  const a = address || {};
  const line1 = clean(a.line1);
  const flat = clean(a.flat_number);
  if (a.apartment_id || !flat || startsWithFlat(line1, flat)) return line1;
  return line1 ? `${flat}, ${line1}` : flat;
}

/** `{ text, missing }` for the line under a customer's name.
 *  missing = no flat number on file (the screen flags it only in stores that
 *  require one). */
export function unitLabel(address) {
  const a = address || {};
  const flat = clean(a.flat_number);
  if (a.apartment_id || clean(a.apartment_name)) {
    const apt = clean(a.apartment_name) || "Apartment";
    return flat ? { text: `Flat ${flat} · ${apt}`, missing: false } : { text: apt, missing: true };
  }
  const line1 = clean(a.line1);
  if (flat) {
    const rest = startsWithFlat(line1, flat) ? line1.replace(new RegExp(`^(flat\\s+)?${flat.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}[,\\s]*`, "i"), "") : line1;
    return { text: rest ? `Flat ${flat} · ${rest}` : `Flat ${flat}`, missing: false };
  }
  return { text: line1, missing: true };
}
